// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box .el-message-box__btns .el-button.el-button--default:focus,.el-message-box .el-message-box__btns .el-button.el-button--default:hover{color:#15a675;background:#fff;border-color:#15a675}.el-message-box .el-message-box__btns .el-button.el-button--default.el-button--primary,.el-message-box .el-message-box__btns .el-button.el-button--primary{color:#fff;background:#b60005;border-color:#b60005}.report_type .report_type__tips{font-size:12px;color:#999}", ""]);
// Exports
module.exports = exports;
